import { useState, useEffect } from "react";

export default function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);

  return isMobile;
}

export function useIsTablet() {
  const getIsTablet = () =>
    typeof window !== "undefined" &&
    window.innerWidth > 640 &&
    window.innerWidth <= 1180;

  const [isTablet, setIsTablet] = useState(getIsTablet);

  useEffect(() => {
    const handler = () => setIsTablet(getIsTablet());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return isTablet;
}
